import React from "react";
import { useTranslation } from "react-i18next";
export default function ProfileButtonBar({
    saving = false,
    onSave,
    onCancel,
    showCancel = true,
    saveLabel = "Enregistrer",
    cancelLabel = "Annuler"

}) {
const { t } = useTranslation();

    return (
        <div className="profile-button-bar">
            <hr className="mb-4"/>
            <div className="d-flex justify-content-end gap-3">
                {
                    showCancel &&
                    <button
                        type="button"
                        className="btn btn-outline-secondary px-4"
                        onClick={onCancel}
                        disabled={saving}
                    >
                        <i className="bi bi-arrow-left me-2"></i>
                       {t("button.cancel")}
                    </button>

                }
                <button
                    type="submit"
                    className="btn btn-primary px-5"
                    disabled={saving}
                    onClick={onSave}
                >
                    {
                        saving
                        ?
                        <>
                            <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                            />
                           {t("button.save")}
                        </>
                        :
                        <>
                            <i className="bi bi-check-circle me-2"></i>

                          {t("button.save")}
                        </>
                    }
                </button>
            </div>
        </div>
    );

}